import router from '../router'
import { http } from '../plugins/axios'

export const actions = {
  login ({ commit }, payload) {
    let url = 'login'
    let params = {
      'email': payload.event.email,
      'password': payload.event.password
    }
    http.defaults.headers.common['X-localization'] = payload.event.context.lang
    http.post(url, params)
      .then(
        response => {
          localStorage.setItem('token', JSON.stringify({
            access_token: response.data.data.access_token,
            expires_in: response.data.data.expires_in,
            refresh_token: response.data.data.refresh_token,
            token_type: response.data.data.token_type
          }))
          commit('login', {
            email: payload.event.email,
            access_token: response.data.data.access_token,
            expires_in: response.data.data.expires_in,
            refresh_token: response.data.data.refresh_token,
            token_type: response.data.data.token_type
          })
          router.replace('/')
        },
        error => {
          if (error.response.data.errors) {
            payload.event.context.errors = error.response.data.errors
          }
          payload.event.context.showNotification(error.response, 'error', -1)
          payload.event.context.loading = false
        }
      )
  },
  logout ({ commit }) {
    let url = 'logout'
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(
        response => {
          localStorage.clear()
          commit('logout', {response})
          router.replace('/auth/login')
        },
        error => {
          localStorage.removeItem('token')
          commit('logout', {error})
          router.replace('/auth/login')
        }
      )
  },
  requestChangePassword ({ commit }, payload) {
    let url = 'password'
    http.defaults.headers.common['X-localization'] = payload.event.context.lang
    let params = {
      'email': payload.event.email
    }
    http.put(url, params)
      .then(response => {
        commit('onRequestChangePassword', {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  resetPassword ({ commit }, payload) {
    let url = 'password/reset'
    let params = payload.event.params
    http.defaults.headers.common['X-localization'] = payload.event.context.lang
    http.post(url, params)
      .then(response => {
        commit('onChangePassword', {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  changePassword ({commit}, payload) {
    let url = 'change-password'
    http.defaults.headers.common['X-localization'] = payload.event.context.lang
    let params = {
      'oldPassword': payload.event.item.oldPassword,
      'newPassword': payload.event.item.newPassword,
      'confirmPassword': payload.event.item.confirmPassword
    }
    http.put(url, params, {})
      .then(
        response => {
          commit('onChangePass', {event: payload.event, response})
        },
        error => {
          commit('onErrorPass', {event: payload.event, error})
        }
      )
  },
  getFiscal ({commit}, payload) {
    let url = 'fiscal-regimen'
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options).then(response => {
      commit('onGetFiscal', { event: payload.event, response })
    })
  },
  getCountry ({commit}, payload) {
    let url = 'country?perPage=249'
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(response => {
        commit('onGetCountry', {event: payload.event, response})
      })
  },
  getContacts ({commit}, payload) {
    let url = `contact`
    let options = {
      emulateJSON: false
    }
    let params = {
      "perPage": payload.event.item.perPage,
      "page": payload.event.item.page,
      "sortKey": payload.event.item.sortKey,
      "ord": payload.event.item.ord,
      "find": payload.event.item.find !== '' ? payload.event.item.find : undefined
    }
    http.get(url, { params }, options)
      .then(response => {
        commit('onGetContacts',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  deleteContact ({commit}, payload) {
    let url = `contact/${payload.event.item.id}`
    http.delete(url, {}, {})
      .then(
        response => {
          commit('onDeleteContact', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  getFile ({commit}, payload) {
    let url = `file/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
        .then(response => {
          commit('onGetFile', {event: payload.event, response})
        })
  },
  userLogged ({ commit }, payload) {
    let url = 'userlogged'
    let options = {
      emulateJSON: true
    }
    http.defaults.headers.common['X-device'] = 'WEB'
    http.defaults.headers.common['X-version'] = '1.0'
      http.get(url, {}, options)
        .then(
          response => {
            commit('onUserLogged', {event: payload.event, response})
          },
          error => {
            commit('onErrorLogged', {event: payload.event, error})
          }
        )
  },
  changeLanguage ({ commit }, payload) {
    let url = 'lang'
    http.post(url, payload.event.data)
      .then(
        response => {
          commit('onChangeLanguage', {event: payload.event, response})
        },
        error => {
          commit('onErrorPass', {event: payload.event, error})
        }
      )
  },
  /** Peticion para devolver la lista de zonas horarias */
  getTimeZone ({commit}, payload) {
    let url = 'timezone'
    let options = {
      emulateJSON: true
    }
    let params = {
      'perPage': payload.event.item.perPage,
      'page': payload.event.item.page,
      'find': payload.event.item.search !== '' ? payload.event.item.search : undefined,
      'sortKey': payload.event.item.sort ? payload.event.item.sort : 'label',
      'ord': payload.event.item.ord
    }
    http.get(url, { params }, options)
      .then(response => {
        commit('onGetTimeZone', { event: payload.event, response })
      },
      error => {
        commit('onError', { event: payload.event, error })
      }
    )
  }
}